// @flow

import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import styled from 'styled-components';

import Page from '../components/Page';
import Section from '../components/Section';
import SignUpForm from '../components/SignUp';

const SignUpSection = styled(Section)`
  h3 {
    margin-top: 0;
  }
`;

const NoLink = styled.a`
  color: ${props => props.theme.text.light};
  cursor: pointer;
  display: block;
  font-size: 14px;
  text-decoration: none;
  text-align: center;
  &:hover, &:active &:focus {
    text-decoration: underline;
  }
`;

type Props = {
  bypassName: string,
  bypassMessage: string,
  location: { [string]: mixed }
}

type State = {
  redirectToReferrer: boolean
}

class SignUp extends Component<Props, State> {

  state = {
    redirectToReferrer: false
  }

  static defaultProps = {
    bypassName: 'bypass',
    bypassMessage: 'No thanks, just show me the calculator'
  }

  bypassForm = () => {
    // console.log('bypassForm');

    if (window.Modernizr.localstorage) {
      localStorage.setItem(this.props.bypassName, 'true');
    }

    this.setState({
      redirectToReferrer: true
    });
  }

  onSignUp = () => {
    this.bypassForm();
  }

  render() {
    let from = this.props.location.state;
    if (!from) {
      from = { referrer: { pathname: '/' } };
    }

    if (this.state.redirectToReferrer) {
      return <Redirect to={{
        pathname: '/tools/vortex/calculator',
        state: { bypass: true }
      }} />;
    }

    return (
      <Page title="Sign Up">
        <SignUpSection light>
          <SignUpForm
            action="Subscribe and Continue"
            autofocus={true}
            onSignUp={this.onSignUp}
          />
          <NoLink onClick={this.bypassForm}>
            {this.props.bypassMessage}
          </NoLink>
        </SignUpSection>
      </Page>
    );
  }

}

export default SignUp;



// WEBPACK FOOTER //
// ./src/views/SignUp.js